import { render, staticRenderFns } from "./Fraudulent.vue?vue&type=template&id=33e227fe&scoped=true"
import script from "./Fraudulent.vue?vue&type=script&lang=js"
export * from "./Fraudulent.vue?vue&type=script&lang=js"
import style0 from "./Fraudulent.vue?vue&type=style&index=0&id=33e227fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e227fe",
  null
  
)

export default component.exports